import axios, { handleErrorResponse, redirectToErrorPage } from './axios-config';
import { addAuthorizationHeader, addTrackingHeader, buildApiEndpoint, getRequestBody } from '../helper-fns/apiHelper';
import {
	IPaymentStatusRequest,
	IPaymentStatusResponse,
	IPayPalPreauthorizationRequest,
	IPreauthorizationRequest,
	IPreauthorizationResponse,
	ISepaMandateRequest,
	ISepaMandateResponse,
	ISepaPreauthorizationRequest,
	ICheckIbanResponse,
	Locales,
	IApiErrorResponse,
	ISepaAmendMandateRequest,
	ISepaAmendPreauthorizationRequest,
	IAmendPreauthorizationRequest,
	IPayPalAmendPreauthorizationRequest,
} from '../models';

export const PayOneService = {
	preauthorization: async (
		body: IPreauthorizationRequest,
		token: string | null,
		lang?: Locales,
	): Promise<IPreauthorizationResponse> => {
		const config = addAuthorizationHeader(token);
		return await axios
			.post(
				buildApiEndpoint(`/payone/creditcard/preauthorization`),
				getRequestBody({ body, lang }),
				addTrackingHeader(config),
			)
			.then(({ data }) => data)
			.catch((res: IApiErrorResponse) => handleErrorResponse(res, lang));
	},
	amendPreauthorization: async (
		body: IAmendPreauthorizationRequest,
		token: string | null,
		lang?: Locales,
	): Promise<IPreauthorizationResponse> => {
		const config = addAuthorizationHeader(token);
		return await axios
			.post(
				buildApiEndpoint(`/payone/creditcard/amendPreauthorization`),
				getRequestBody({ body, lang }),
				addTrackingHeader(config),
			)
			.then(({ data }) => data)
			.catch((res: IApiErrorResponse) => handleErrorResponse(res, lang));
	},
	payPalPreauthorization: async (
		body: IPayPalPreauthorizationRequest,
		token: string | null,
		lang?: Locales,
	): Promise<IPreauthorizationResponse> => {
		const config = addAuthorizationHeader(token);
		return await axios
			.post(
				buildApiEndpoint(`/payone/paypal/preauthorization`),
				getRequestBody({ body, lang }),
				addTrackingHeader(config),
			)
			.then(({ data }) => data)
			.catch((res: IApiErrorResponse) => handleErrorResponse(res, lang));
	},
	payPalAmendPreauthorization: async (
		body: IPayPalAmendPreauthorizationRequest,
		token: string | null,
		lang?: Locales,
	): Promise<IPreauthorizationResponse> => {
		const config = addAuthorizationHeader(token);
		return await axios
			.post(
				buildApiEndpoint(`/payone/paypal/amendPreauthorization`),
				getRequestBody({ body, lang }),
				addTrackingHeader(config),
			)
			.then(({ data }) => data)
			.catch((res: IApiErrorResponse) => handleErrorResponse(res, lang));
	},
	manageMandate: async (
		body: ISepaMandateRequest,
		token: string | null,
		lang?: Locales,
	): Promise<ISepaMandateResponse> => {
		const config = addAuthorizationHeader(token);
		return await axios
			.post(
				buildApiEndpoint(`/payone/sepa/managemandate`),
				getRequestBody({ body, lang }),
				addTrackingHeader(config),
			)
			.then(({ data }) => data)
			.catch((res: IApiErrorResponse) => handleErrorResponse(res, lang));
	},
	amendManageMandate: async (
		body: ISepaAmendMandateRequest,
		token: string | null,
		lang?: Locales,
	): Promise<ISepaMandateResponse> => {
		const config = addAuthorizationHeader(token);
		return await axios
			.post(
				buildApiEndpoint(`/payone/sepa/amendManagemandate`),
				getRequestBody({ body, lang }),
				addTrackingHeader(config),
			)
			.then(({ data }) => data)
			.catch((res: IApiErrorResponse) => handleErrorResponse(res, lang));
	},
	sepaPreauthorization: async (
		body: ISepaPreauthorizationRequest,
		token: string | null,
		lang?: Locales,
	): Promise<IPreauthorizationResponse> => {
		const config = addAuthorizationHeader(token);
		return await axios
			.post(
				buildApiEndpoint(`/payone/sepa/preauthorization`),
				getRequestBody({ body, lang }),
				addTrackingHeader(config),
			)
			.then(({ data }) => data)
			.catch((res: IApiErrorResponse) => handleErrorResponse(res, lang));
	},
	amendSepaPreauthorization: async (
		body: ISepaAmendPreauthorizationRequest,
		token: string | null,
		lang?: Locales,
	): Promise<IPreauthorizationResponse> => {
		const config = addAuthorizationHeader(token);
		return await axios
			.post(
				buildApiEndpoint(`/payone/sepa/amendPreauthorization`),
				getRequestBody({ body, lang }),
				addTrackingHeader(config),
			)
			.then(({ data }) => data)
			.catch((res: IApiErrorResponse) => handleErrorResponse(res, lang));
	},
	getPaymentStatus: async (
		body: IPaymentStatusRequest,
		token: string | null,
		lang?: Locales,
	): Promise<IPaymentStatusResponse> => {
		const config = addAuthorizationHeader(token);
		return await axios
			.post(
				buildApiEndpoint(`/payone/getPaymentStatus`),
				getRequestBody({ body, lang }),
				addTrackingHeader(config),
			)
			.then(({ data }) => data)
			.catch((res: IApiErrorResponse) => handleErrorResponse({ ...res, paymentError: true }, lang));
	},
	checkIban: async (body: { iban: string; dkv: boolean }, lang?: Locales): Promise<ICheckIbanResponse> =>
		await axios
			.post(buildApiEndpoint(`/payone/sepa/checkIban`), getRequestBody({ body, lang }), addTrackingHeader())
			.then(({ data }) => data)
			.catch(() => redirectToErrorPage()),
};
